import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import columns from './HouseOfferAmountTableConfig';
import FunctionalTableComponent from '../../../components/table/FunctionalTableComponent';

const HouseOfferAmount = ({ paymentSummary }) => {
  const [loader, setLoader] = useState(false);
  const [reload, setReload] = useState(false);

  const navigate = useNavigate();
  let { id } = useParams();

  return (
    <>
      <FunctionalTableComponent
        shadow={false}
        title={'Szczegóły ceny'}
        columns={columns}
        header={false}
        removable={false}
        initialData={paymentSummary.dailyAmounts}
        editable={false}
        pagination={false}
        tableHeader={true}
        width={12}
        noCard={true}
      />
    </>
  );
};

export default HouseOfferAmount;
